import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconService } from '@isophi/core-ui';
import { Document } from '@isophi/teachers-shared';

import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-material-single',
    templateUrl: './material-single.component.html',
    styleUrls: ['./material-single.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MaterialSingleComponent {
  @Input() document: Document;

  @Input() title?: string;

  materialServer: string;

  constructor(public icons: IconService) {
    this.materialServer = environment.materialServer;
  }
}
